<template>
  <div
    :class="[
      'flex items-center justify-center p-4',
      fullscreen ? 'fixed inset-0 bg-white/80 dark:bg-black/80 z-50' : ''
    ]"
    role="status"
    :aria-label="message"
  >
    <div class="flex flex-col items-center">
      <div
        class="w-8 h-8 border-4 rounded-full animate-spin"
        :class="[
          fullscreen ? 'w-12 h-12' : 'w-8 h-8',
          isDark ? 'border-blue-400 border-t-transparent' : 'border-blue-600 border-t-transparent'
        ]"
      ></div>
      <span
        v-if="message"
        :class="[
          'mt-3',
          isDark ? 'text-gray-300' : 'text-gray-600',
          fullscreen ? 'text-lg' : 'text-sm'
        ]"
      >
        {{ message }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from '../../../utils/useTheme'

const props = defineProps<{
  message?: string
  fullscreen?: boolean
}>()

const theme = useTheme()
const isDark = computed(() => theme.isDark.value)
</script>

<style scoped>
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
